import { Modal } from '@mantine/core';
import { useState, useEffect } from 'react';

import styles from './ImageViewerModal.module.scss';
import { Props } from './ImageViewerModal.types';

const ImageViewerModal = ({ open, imageUrl, onClose }: Props) => {
  const [imageLoaded, setImageLoaded] = useState(false);

  useEffect(() => {
    if (open) {
      setImageLoaded(false);
    }
  }, [open, imageUrl]);

  return (
    <Modal opened={open} onClose={onClose} withCloseButton={true} size="xl">
      <div className={styles.container}>
        <img
          src={imageUrl}
          onLoad={() => setImageLoaded(true)}
          className={styles.image}
          style={{
            visibility: imageLoaded ? 'visible' : 'hidden',
          }}
        />
      </div>
    </Modal>
  );
};

export default ImageViewerModal;
